<template>
  <div class="flex items-start">
    <div class="mt-[8px] flex-shrink-0 font-bold">{{ tag.tag_name }}</div>
    <div class="ml-[12px] flex flex-wrap">
      <div v-for="child in tag.children" :key="child.tag_name" class="px-[4px] py-[8px]">
        <div class="tag" :class="{ 'cursor-default': !child.tag_id }" @click="onClick(child)">
          {{ child.tag_name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { DetailTag } from './detail-description/interface';
import type { Character } from '~/api/interface/character';
import { PageKey } from '~/constants/page';

interface TagProps {
  tag: DetailTag;
  character?: Character | null;
}

const props = defineProps<TagProps>();

const resourceLocation = injectResourceLocation();

function onClick(childTag: DetailTag) {
  if (childTag.tag_id) {
    navigateTo({
      name: PageKey.CHARACTER,
      query: {
        tag_ids: `${props.tag.tag_id}.${childTag.tag_id}`,
      },
    });
  }

  trackEvent(TRACK_EVENT.CLICK_CHARACTER_TAG, {
    id: props.character?.id,
    name: props.character?.name,
    look_name: props.character?.look_name,
    tag_id: childTag.tag_id,
    tag_name: childTag.tag_name,
    source: resourceLocation?.source,
    tags: props.character?.tags,
  });
}
</script>
<style lang="scss" scoped>
.tag {
  padding: 5px 12px;
  border-radius: 12px;
  font-size: 12px;
  background: var(--purple-1);
  color: var(--primary-color);
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  & + & {
    margin-left: 8px;
  }

  @media (max-width: 680px) {
    pointer-events: none;
  }
}
</style>
